/**
 * Which screen the operator is on, for the Ask Dink role strip and starters
 * (DNKADM-0460 items 5 and 7).
 *
 * The name is the nav leaf's own label (`navModel`, the same longest-prefix rule the
 * sidebar highlight uses), so the strip says "Users" where the menu does. One detail
 * page is named on its own: `/members/<id>` is "Member detail", because it has its own
 * starters. A path outside the nav has no name and the strip leaves it out.
 */
import { ALL_NAV_LEAVES, activeNavPath } from '@/components/navModel';
import type { StarterScreen } from './askDinkStarters';

export interface AskDinkScreen {
  /** The screen's name, or null when the path is not a nav screen. */
  name: string | null;
  /** The screen's own starter set, or null when it falls back to the default. */
  starters: StarterScreen | null;
}

export const MEMBER_DETAIL = /^\/members\/[^/]+\/?$/;

export function askDinkScreen(pathname: string): AskDinkScreen {
  if (MEMBER_DETAIL.test(pathname)) return { name: 'Member detail', starters: 'memberDetail' };
  const navPath = activeNavPath(pathname);
  const leaf = ALL_NAV_LEAVES.find((l) => l.path === navPath);
  const starters: StarterScreen | null =
    navPath === '/reservations'
      ? 'reservations'
      : navPath === '/transaction-ledger'
        ? 'transactionLedger'
        : null;
  return { name: leaf?.label ?? null, starters };
}
